import { useTranslation } from 'react-i18next';
import { Card, CardContent, Text } from '@shared/ui';

const RADIUS_STEPS = [
  { key: 'uiLibrary.tokens.radius.none', className: 'rounded-none' },
  { key: 'uiLibrary.tokens.radius.sm', className: 'rounded-sm' },
  { key: 'uiLibrary.tokens.radius.md', className: 'rounded-md' },
  { key: 'uiLibrary.tokens.radius.lg', className: 'rounded-lg' },
  { key: 'uiLibrary.tokens.radius.full', className: 'rounded-full' },
];

export function RadiusScale() {
  const { t } = useTranslation();
  const translate = (key: string) => t(key as never) as string;

  return (
    <Card>
      <CardContent className="flex flex-wrap gap-4 p-6">
        {RADIUS_STEPS.map((radius) => (
          <div key={radius.key} className="flex flex-col items-center gap-2">
            <div className={`h-10 w-16 border border-border bg-card ${radius.className}`} />
            <Text size="xs" color="muted">
              {translate(radius.key)}
            </Text>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
